import axios from "axios";
import { PROVIDERS_CUSTOMER } from "../../../../config";
import { DataTableHelper } from "../../../../utilities/helpers/DataTableHelper";

export function getProviderCustomers(
	sortParam,
	pageSize,
	pageNumber,
	searchParam = '',
	createDateParam = '',
	filterStatusParams = [],
	filterPaymentStatusParams = []
) {
	return axios.get(
		PROVIDERS_CUSTOMER +
			( DataTableHelper.prepareParameters(
				sortParam,
				pageSize,
				pageNumber,
				null,
				searchParam,
				createDateParam,
				filterStatusParams,
				filterPaymentStatusParams
		)),
	);
}
// Lightweight customer lookup for pickers (e.g. the new-booking search).
// Returns the first page of newest customers matching the query.
export function searchCustomers(query) {
	return getProviderCustomers(
		{ value: 'created_at', direction: 'desc' },
		10,
		0,
		query
	);
}

export function getProviderCustomer(CutomerId) {
	return axios.get(PROVIDERS_CUSTOMER+'/'+CutomerId);
}
export function createCutomer(data) {
	return axios.post(PROVIDERS_CUSTOMER , data);
}

export function updateCustomerInfo(updateCustomerId, data) {
    return axios.put(PROVIDERS_CUSTOMER + '/' + updateCustomerId, data);
}

export function deleteCutomer(deleteCutomerId) {
	return axios.delete(PROVIDERS_CUSTOMER + '/' + deleteCutomerId);
}